module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("誤字脱字を報告する")])]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("セット名")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.setName),
      callback: function($$v) {
        _vm.setName = $$v
      },
      expression: "setName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-group"
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "endHour"
    }
  }, [_vm._v("フィガー")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "figureSummary",
      "id": "figureSummary"
    },
    model: {
      value: (_vm.figureNumber),
      callback: function($$v) {
        _vm.figureNumber = $$v
      },
      expression: "figureNumber"
    }
  }, _vm._l((_vm.set.figures), function(figure, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(_vm.getFigureSummary(figure)))])
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "field-group"
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "movement"
    }
  }, [_vm._v("ムーブメント")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "movement",
      "id": "movement"
    },
    model: {
      value: (_vm.movement),
      callback: function($$v) {
        _vm.movement = $$v
      },
      expression: "movement"
    }
  }, _vm._l((_vm.figure.movements), function(mv, index) {
    return _c('md-option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (mv.summary),
        expression: "mv.summary"
      }],
      key: index,
      attrs: {
        "value": mv.summary
      }
    }, [_vm._v(_vm._s(mv.summary))])
  }))], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.commentError),
      expression: "!commentError"
    }],
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("コメント")]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentError),
      expression: "commentError"
    }],
    staticClass: "md-input-invalid",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("コメント")]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    model: {
      value: (_vm.commentError),
      callback: function($$v) {
        _vm.commentError = $$v
      },
      expression: "commentError"
    }
  }, [_vm._v(_vm._s(_vm.commentError))])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "id": "addReport"
    },
    on: {
      "click": function($event) {
        _vm.addReport('dialog5')
      }
    }
  }, [_vm._v("報告する")])], 1)], 1), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("セット")]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-numeric": ""
    }
  }, [_vm._v("フィガー")]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-numeric": ""
    }
  }, [_vm._v("ムーブメント")]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-numeric": ""
    }
  }, [_c('md-icon', [_vm._v("message")]), _vm._v(" コメント")], 1)], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.reports), function(report, index) {
    return _c('md-table-row', {
      key: index
    }, [_c('md-table-cell', [_vm._v(_vm._s(report.setName))]), _vm._v(" "), _c('md-table-cell', {
      attrs: {
        "md-numeric": ""
      }
    }, [_vm._v(_vm._s(report.figureSummary))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(report.movement))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(report.description) + "\n          "), (report.state === 'closed') ? _c('md-chip', {
      key: "stateClosed"
    }, [_vm._v("対応済み")]) : _c('md-chip', {
      key: "statePending",
      staticClass: "md-primary"
    }, [_vm._v("処理中")])], 1)], 1)
  }))], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "dialog3",
    attrs: {
      "md-content": _vm.dialog.content,
      "md-ok-text": _vm.dialog.ok
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b31e202","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report.vue
// module id = 341
// module chunks = 1